/**
 * Verificacion del carro contra el stock real (CHK-05).
 *
 * Es la unica llamada del sitio que manda el carro al servidor, y ocurre en el
 * checkout, no al agregar al carro: el stock cambia mientras el comprador
 * navega.
 */
import type { Carro, RespuestaVerificacionStock } from '@bandu/compartido';

import { pedir } from './cliente-api';

export function verificarCarro(
  carro: Carro,
  senal?: AbortSignal,
): Promise<RespuestaVerificacionStock> {
  return pedir<RespuestaVerificacionStock>('/carro/verificar', {
    metodo: 'POST',
    cuerpo: {
      items: carro.items.map((item) => ({ sku: item.producto.sku, cantidad: item.cantidad })),
    },
    ...(senal ? { senal } : {}),
  });
}
